import Route from '@ember/routing/route';

export default class UsageSetsRoute extends Route {}
